import { render, staticRenderFns } from "./CreditScoringBudidaya.vue?vue&type=template&id=334fc7ff&scoped=true&"
import script from "./CreditScoringBudidaya.vue?vue&type=script&lang=js&"
export * from "./CreditScoringBudidaya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334fc7ff",
  null
  
)

export default component.exports